// extracted by mini-css-extract-plugin
export default {"buttonLight":"FileDelete_buttonLight__wdR+R"};